var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('PageTitle',{attrs:{"title":_vm.pageTitle}}),_c('AdministrationBreadcrumb',{attrs:{"crumbs":_vm.crumbs}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }